import React from 'react'

const AppFooter = () => {
  return (
    <div className="main-footer">
      <p>
        Powered by&nbsp;
        <a href="https://www.tarainteractive.com/" target="_blank" rel="noopener noreferrer">
          TARA Interactive
        </a>
      </p>
    </div>
  )
}

export default React.memo(AppFooter)
